







































// eslint-disable-next-line
import { Component, Prop, Vue } from "vue-property-decorator";

interface Post {
  title: string;
  body: string;
  author: { name: string };
  date: Date;
  lastUpdated: Date;
}

type Maybe<T> = T | null;

@Component
export default class PostForm extends Vue {
  public postId: Maybe<string> = null;
  public postTitle: Maybe<string> = null;
  public postBody: Maybe<string> = null;
  public errors: Maybe<string[]> = null;

  created() {
    if (this.hasPostIdPassed()) {
      this.postId = this.$route.params.id;
      this.getPassedPost().then(data => {
        this.postTitle = data.title;
        this.postBody = data.body;
      });
    }
  }

  public isLoggedIn(): boolean {
    return this.$store.state.currentUser.loggedIn;
  }

  public hasPostIdPassed(): boolean {
    return this.$route.params.id ? true : false;
  }

  private async getPassedPost(): Promise<Post> {
    const post = await fetch(process.env.VUE_APP_API_URL + "/posts/" + this.$route.params.id, { method: "GET" });
    const result = await post.json();
    return result.data;
  }

  public async savePost(e: Event): Promise<void> {
    const payload = {
      _id: this.postId,
      title: (e.target as HTMLFormElement).posttitle.value,
      body: (e.target as HTMLFormElement).body.value
    };
    const url = this.hasPostIdPassed()
      ? process.env.VUE_APP_API_URL + "/posts/" + this.postId
      : process.env.VUE_APP_API_URL + "/posts";
    const response = await fetch(url, {
      method: this.hasPostIdPassed() ? "PATCH" : "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$store.state.currentUserToken
      },
      body: JSON.stringify(payload)
    });
    const result = await response.json();
    if (result.status !== 200) {
      this.errors = result.msg;
      this.$forceUpdate();
      console.log(result);
    } else {
      this.$router.push("/");
    }
  }
}
